// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subcategory-list .item-body[data-v-06990433]:not(:last-child){margin-bottom:15px}.subcategory-list .item-body .subcategory-list-item[data-v-06990433]{border:2px solid #c5e1ef!important;color:#22376c;font-weight:600;padding:10px;text-align:center;cursor:pointer}", ""]);
// Exports
module.exports = exports;
